import { render, staticRenderFns } from "./ResetSucess.vue?vue&type=template&id=3a61a250&scoped=true&"
import script from "./ResetSucess.vue?vue&type=script&lang=js&"
export * from "./ResetSucess.vue?vue&type=script&lang=js&"
import style0 from "./ResetSucess.vue?vue&type=style&index=0&id=3a61a250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a61a250",
  null
  
)

export default component.exports